import { PageViewEventLogger } from '@repo/tracking-service';
import { AuthGuard } from '@repo/user-session';
import { Suspense } from 'react';

import { MyPageContent, MyPageFallback } from '@/components/my';
import s from '@/components/my/common/layout.module.scss';
import { MyTopNavigation } from '@/components/my/page/MyTopNavigation';

export default function MyPage() {
  return (
    <AuthGuard>
      <PageViewEventLogger pageName={'my-info'}>
        <MyTopNavigation />
        <main className={s.main_content}>
          <Suspense fallback={<MyPageFallback />}>
            <MyPageContent />
          </Suspense>
        </main>
      </PageViewEventLogger>
    </AuthGuard>
  );
}
